/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const MenuMyAutomationsIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#6794BA',
  colorSecondary = '#B9D2E5',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18422_10645)">
        <path d="M11.25 0H28.75V7.5H11.25V0Z" fill={colorSecondary} />
        <path d="M0 32.5H17.5V40H0V32.5Z" fill={colorSecondary} />
        <path d="M22.5 32.5H40V40H22.5V32.5Z" fill={colorSecondary} />
        <path d="M11.25 12.5H28.75V20H11.25V12.5Z" fill={colorSecondary} />
        <path d="M18.75 7.5H21.25V27.5H18.75V7.5Z" fill={color} />
        <path d="M7.5 25H32.5V27.5H7.5V25Z" fill={color} />
        <path d="M30 27.5H32.5V32.5H30V27.5Z" fill={color} />
        <path d="M7.5 27.5H10V32.5H7.5V27.5Z" fill={color} />
        <path d="M18.75 12.5H21.25V20H18.75V12.5Z" fill={color} />
        <path d="M18.75 5H21.25V7.5H18.75V5Z" fill={color} />
        <path d="M30 32.5H32.5V35H30V32.5Z" fill={color} />
        <path d="M7.5 32.5H10V35H7.5V32.5Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_18422_10645">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
